<template>
    <div
        v-qa="'page-500'"
        class="page-500"
    >
        <ErrorFiveHundredMessage
            :errors
            :show-server-errors-for-non-admin
        >
            <template #default>
                <slot name="default"></slot>
            </template>
        </ErrorFiveHundredMessage>
    </div>
</template>

<script setup lang="ts">
import { useSetStatus } from 'wucdbm-vite-vue-ssr'

import type { ErrorCollectionWithTraces } from '@/helpers/errors'

import ErrorFiveHundredMessage from '@/components/ui/error/ErrorFiveHundredMessage.vue'

defineProps<{
    errors: ErrorCollectionWithTraces
    showServerErrorsForNonAdmin?: boolean
}>()

const { setStatus } = useSetStatus()
setStatus(500)
</script>

<style lang="scss" scoped>
.page-500 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10vh 0 20vh;
}
</style>
